window.CartDrawerExtras = window.CartDrawerExtras || {
  __inited: false,
  init() {
    if (this.__inited) return;
    this.__inited = true;
    const DRAWER_SEL = "#cart-drawer";
    const ITEMS_ROOT = "#cart-drawer [data-cart-items]";
    const ITEM_TMPL_ID = "#cart-item-template";
    const SUBTOTAL_SEL = "#cart-drawer [data-cart-subtotal], #cart-drawer [data-checkout-total]";
    const RECO_ROOT_ID = "cart-drawer-recos";

    const $ = (s, r) => (r || document).querySelector(s);
    const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

    function formatMoney(cents) {
      const val = parseInt(cents, 10) || 0;
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        try {
          return Shopify.formatMoney(
            val,
            (window.theme && theme.moneyFormat) || "${{amount}}"
          );
        } catch (e) {}
      }
      const fmt = (window.theme && theme.moneyFormat) || "${{amount}}";
      const amount = (val / 100).toFixed(2);
      return fmt
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          Math.round(val / 100)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        )
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          amount.replace(".", ",")
        )
        .replace(
          /\{\{\s*amount_no_decimals\s*\}\}/g,
          Math.round(val / 100).toString()
        )
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    async function getCart() {
      const r = await fetch("/cart.js", { credentials: "same-origin" });
      return r.json();
    }
    async function changeLine(key, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then((r) => r.json());
    }

    let refreshing = false;
    async function refreshCartDrawer(openIt = true) {
      if (refreshing) return;
      refreshing = true;

      const drawer = $(DRAWER_SEL);
      const itemsEl = $(ITEMS_ROOT);
      const tmpl = $(ITEM_TMPL_ID);

      if (!itemsEl || !tmpl) {
        refreshing = false;
        return;
      }

      try {
        itemsEl.classList.add("is-busy");

        if (openIt && drawer && drawer.getAttribute("aria-hidden") === "true") {
          if (window.CartDrawer?.open) {
            try {
              window.CartDrawer.open();
            } catch (e) {}
          }
          if (window.cartDrawer?.open) {
            try {
              window.cartDrawer.open();
            } catch (e) {}
          }
          try {
            drawer.setAttribute("aria-hidden", "false");
          } catch (e) {}
        }

        const cart = await getCart();

        itemsEl.innerHTML = "";
        (cart.items || []).forEach((it, idx) => {
          const node = tmpl.content.cloneNode(true);
          const art = $("[data-line]", node);

          // Set the line number for proper remove functionality
          if (art) {
            art.setAttribute('data-line', idx + 1);
          }

          const aImg = $(".cart-item__image", node);
          const img = aImg ? $("img", aImg) : null;
          const aTit = $(".cart-item__title", node);
          const opt = $("[data-variant]", node);
          const props = $("[data-props]", node);
          const qtyI = $("[data-qty]", node);
          const qMin = $("[data-qty-minus]", node);
          const qPls = $("[data-qty-plus]", node);
          const rmv = $("[data-remove]", node);
          const pNow = $("[data-line-price]", node);
          const pCmp = $("[data-line-compare]", node);

          const href = it.url || (it.handle ? "/products/" + it.handle : "#");
          if (aImg) {
            aImg.setAttribute("data-href", href);
            aImg.href = href;
          }
          if (img) {
            const src = (it.image || "").replace(
              /(\.png|\.jpg|\.jpeg|\.webp)(\?.*)?$/i,
              "$1"
            );
            img.src = it.image
              ? src + (src.includes("?") ? "&" : "?") + "width=200"
              : "";
            img.alt = it.product_title || it.title || "";
          }

          if (aTit) {
            const rawTitle = it.product_title || it.title || "";
            aTit.textContent = rawTitle.replace(/^\s*lectron[\s-]*/i, '');
            aTit.href = href;
          }

          if (opt) {
            const vt = it.variant_title || "";
            opt.textContent = vt;
          }

          if (props) {
            const pr = it.properties || {};
            const keys = Object.keys(pr).filter(
              (k) => pr[k] != null && pr[k] !== ""
            );
            props.innerHTML = keys.length
              ? keys.map((k) => `<div>${k}: ${String(pr[k])}</div>`).join("")
              : "";
          }

          if (qtyI) {
            qtyI.value = it.quantity;
            qtyI.min = 0;
            qtyI.step = 1;
            qtyI.inputMode = "numeric";
          }

          if (pNow) pNow.textContent = formatMoney(it.final_line_price);
          if (pCmp) {
            const cmp = it.original_line_price;
            const show = cmp && cmp > it.final_line_price;
            pCmp.textContent = show ? formatMoney(cmp) : "";
            pCmp.hidden = !show;
          }

          const key = it.key;

          qMin &&
            qMin.addEventListener("click", async () => {
              const newQ = Math.max(0, (parseInt(qtyI.value, 10) || 0) - 1);
              await changeLine(key, newQ);
              await refreshCartDrawer(false);
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
            });

          qPls &&
            qPls.addEventListener("click", async () => {
              const newQ = (parseInt(qtyI.value, 10) || 0) + 1;
              await changeLine(key, newQ);
              await refreshCartDrawer(false);
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
            });

          qtyI &&
            qtyI.addEventListener("change", async () => {
              const newQ = Math.max(0, parseInt(qtyI.value, 10) || 0);
              await changeLine(key, newQ);
              await refreshCartDrawer(false);
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
            });

          rmv &&
            rmv.addEventListener("click", async (e) => {
              e.preventDefault();
              e.stopPropagation();
              await changeLine(key, 0);
              await refreshCartDrawer(false);
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
            });

          itemsEl.appendChild(node);
        });

        const val = formatMoney(cart.total_price || 0);
        $$(SUBTOTAL_SEL).forEach(n => { n.textContent = val; });
        
        requestAnimationFrame(() => {
          $$(SUBTOTAL_SEL).forEach(n => { n.textContent = val; });
        });

        if (window.__bby) {
          try {
            window.__bby.lockButtonsFor?.(3000);
          } catch (e) {}
          try {
            window.__bby.settle?.();
          } catch (e) {}
        }

        [
          "cart:updated",
          "cart:change",
          "cart:refresh",
          "theme:cart-drawer:updated",
        ].forEach((evt) => {
          try {
            document.dispatchEvent(new Event(evt));
          } catch (e) {}
        });
      } finally {
        const itemsEl2 = $(ITEMS_ROOT);
        itemsEl2 && itemsEl2.classList.remove("is-busy");
        refreshing = false;
      }
    }

    window.__cartDrawerRefresh = refreshCartDrawer;

    const recoRoot = document.getElementById(RECO_ROOT_ID);
    if (!recoRoot) return;
    const row = recoRoot.querySelector("[data-recos-row]");
    const prev = recoRoot.querySelector(".recos-prev");
    const next = recoRoot.querySelector(".recos-next");
    if (!row || !prev || !next) return;

    let idxState = 0,
      snapOff = false;

    async function getRecommendations(productId, limit = 12) {
      const r = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}`
      );
      return r.json();
    }
    function imgSrcProduct(p) {
      const src = p.featured_image || (p.images && p.images[0]) || "";
      return src ? `${src}${src.includes("?") ? "&" : "?"}width=160` : "";
    }

    const children = () => Array.from(row.children);
    const count = () => children().length;

    function getTargetLeft(item, container) {
      const itemRect = item.getBoundingClientRect();
      const contRect = container.getBoundingClientRect();
      const padLeft = parseFloat(getComputedStyle(container).paddingLeft) || 0;
      const extra = -20;
      return (itemRect.left - contRect.left) + container.scrollLeft - padLeft + extra;
    }


    function nearestIndexFromScroll() {
      const ch = children();
      if (!ch.length) return 0;
      const padLeft = parseFloat(getComputedStyle(row).paddingLeft) || 0;
      const currentLeft = row.scrollLeft + padLeft;
      let best = 0, bestDist = Infinity;
      for (let i = 0; i < ch.length; i++) {
        const left = getTargetLeft(ch[i], row);
        const d = Math.abs(left - currentLeft);
        if (d < bestDist) { best = i; bestDist = d; }
      }
      return best;
    }

  function easeOutQuart(t){ return 1 - Math.pow(1 - t, 4); }

  function prefersReducedMotion(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  
  function animateScrollLeft(el, to, {duration=500, easing=easeOutQuart} = {}){
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.scrollLeft = to; return Promise.resolve();
    }
    return new Promise(res => {
      const from = el.scrollLeft;
      const diff = to - from;
      const start = performance.now();
      function tick(now){
        const t = Math.min(1, (now - start) / duration);
        el.scrollLeft = from + diff * easing(t);
        if (t < 1) requestAnimationFrame(tick); else res();
      }
      requestAnimationFrame(tick);
    });
  }
      
  function scrollToIndex(i, smooth = true) {
    const n = count(); if (!n) return;
    const idx = ((i % n) + n) % n;
    const target = children()[idx];
    const baseLeft = getTargetLeft(target, row);
  
    if (!smooth) { row.scrollLeft = baseLeft; idxState = idx; return; }
    if (!snapOff) { row.style.scrollSnapType = 'none'; snapOff = true; }
  
    const overshootPx = 16;
    const toOvershoot = baseLeft + overshootPx;
  
    animateScrollLeft(row, toOvershoot, { duration: 660 })
      .then(() => animateScrollLeft(row, baseLeft, { duration: 480 }))
      .finally(() => {
        idxState = idx;
        row.style.scrollSnapType = '';
        snapOff = false;
        row.scrollLeft = getTargetLeft(children()[idxState], row);
    });
  }

    function step(dir) {
      const n = count();
      if (n <= 1) return;
      scrollToIndex(idxState + dir, true);
    }

    function updateArrows() {
      const n = count();
      const enabled = n > 1;
      prev.disabled = !enabled;
      next.disabled = !enabled;
    }

    function renderRecos(products) {
      row.innerHTML = "";
      if (!products || !products.length) {
        recoRoot.hidden = true;
        return;
      }
      recoRoot.hidden = false;

      products.slice(0, 12).forEach((p) => {
        const v = (p.variants && p.variants[0]) || null;
        const price = (v && v.price) || p.price || 0;
        const compare =
          v && v.compare_at_price && v.compare_at_price > price
            ? v.compare_at_price
            : null;
        const available = v ? v.available : p.available;

        const el = document.createElement("article");
        el.className = "rec-item";
        el.innerHTML = `
        <a class="rec-img" href="${p.url}">
          <img loading="lazy" src="${imgSrcProduct(p)}" alt="${p.title.replace(
          /"/g,
          "&quot;"
        )}">
        </a>
        <div class="rec-meta">
          <a class="rec-title" href="${p.url}">${String(p.title || '').replace(/^\s*lectron[\s-]*/i, '')}</a>
          <div class="rec-price">
            <span class="rec-money">${formatMoney(price)}</span>
            ${
              compare
                ? `<del class="rec-money">${formatMoney(compare)}</del>`
                : ``
            }
          </div>
        </div>
        <button class="rec-atc" title="Add to cart"
                data-recos-atc
                ${!available || !v ? "disabled" : ""}
                data-variant-id="${v ? v.id : ""}">Add +</button>
      `;
        row.appendChild(el);
      });

      idxState = 0;
      row.scrollLeft = 0;
      setTimeout(updateArrows, 30);
    }

    async function loadRecos() {
      try {
        const cart = await getCart();
        const first = cart.items && cart.items[0];
        if (!first) {
          recoRoot.hidden = true;
          return;
        }
        const rec = await getRecommendations(first.product_id, 12);
        renderRecos(rec.products || []);
      } catch (e) {
        recoRoot.hidden = true;
      }
    }

    prev.addEventListener("click", () => step(-1));
    next.addEventListener("click", () => step(1));

    let tSync;
    row.addEventListener("scroll", () => {
      clearTimeout(tSync);
      tSync = setTimeout(() => {
        idxState = nearestIndexFromScroll();
        updateArrows();
      }, 60);
    });
    window.addEventListener("resize", () => {
      setTimeout(() => scrollToIndex(idxState, false), 60);
    });

    document.addEventListener("click", async (e) => {
      const btn = e.target.closest("[data-recos-atc]");
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute("data-variant-id");
      if (!id) return;

      try {
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");

        if (window.__bby?.lockButtonsFor) window.__bby.lockButtonsFor(3000);

        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: Number(id), quantity: 1 }),
        });

        await refreshCartDrawer(true);

        loadRecos();
      } finally {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      }
    });

    const drawer = $(DRAWER_SEL);
    if (drawer) {
      new MutationObserver(() => {
        const open = drawer.getAttribute("aria-hidden") !== "true";
        if (open) loadRecos();
      }).observe(drawer, {
        attributes: true,
        attributeFilter: ["aria-hidden"],
      });
    }
    const itemsRoot = $(ITEMS_ROOT);
    if (itemsRoot) {
      new MutationObserver(() => loadRecos()).observe(itemsRoot, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
    ["cart:updated", "cart:change", "cart:refresh"].forEach((evt) =>
      document.addEventListener(evt, loadRecos)
    );

    loadRecos();
  },
};
